import { render, staticRenderFns } from "./breach-partial-view.vue?vue&type=template&id=461144a4&"
import script from "./breach-partial-view.vue?vue&type=script&lang=js&"
export * from "./breach-partial-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports